@if (inventoryAction()) {
  <mat-toolbar class="header">
    <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
      {{ title }}
    </div>

    <div class="expander"></div>

    <button mat-button [mat-menu-trigger-for]="menu"><mat-icon>more_horiz</mat-icon></button>
    <mat-menu #menu="matMenu" hasBackdrop="false">
      <button
        mat-menu-item
        (click)="requestPricing()"
        *ngIf="!isAnswered && !isFinished"
      >
        <mat-icon>send</mat-icon> Reenviar {{'InventoryAction::Pricing' | human}}
      </button>
    </mat-menu>
  </mat-toolbar>
  
  <div class="dialog-wrapper">
    @if(loading()) {
      <mat-spinner></mat-spinner>
    } @else {

      <div class="status-chips">
        <app-chip [color]="inventoryAction().status?.color" [text]="inventoryAction().status?.name"></app-chip>
        <app-chip [color]="isAnswered ? 'green' : 'red'" [text]="isAnswered ? 'Respondida' : 'Sin respuesta'"></app-chip>
        @if (hasExpired) {
          <app-chip color="red" text="Oferta Vencida"></app-chip>
        }
      </div>
      
      <ng-container *ngTemplateOutlet="body"></ng-container>

      <div class="works">
        <div class="label">
          {{'work_assignation' | human}}s
        </div>
        <div class="works-container">
          <app-document-works [order]="inventoryAction()" (load)="this.reloadInventoryAction()()" [modalComponent]="true"></app-document-works>
        </div>
      </div>
    }
  </div>
}

<ng-template #body>
  <div class="info" >
    <div class="name">{{adminService.getText('warehouse')}}</div>
    <div class="value">{{inventoryAction().warehouse?.name | titlecase}}</div>

    <div class="name">Nombre Proveedor</div>
    <div class="value">{{inventoryAction().owner?.name | titlecase}}</div>

    <div class="name">Correo Proveedor</div>
    <div class="value">{{inventoryAction().owner?.email | titlecase}}</div>

    <div class="name">Fecha de Creacion</div>
    <div class="value">{{inventoryAction().created_at | date}}</div>
    @if (inventoryAction().extra_params?.required_delivery_date) {
      <div class="name">Fecha Requerida para Entrega</div>
      <div class="value">{{inventoryAction().extra_params?.required_delivery_date | date}}</div>
    }
    @if (isAnswered) {
      <div class="name">Fecha Estimada para Entrega</div>
      <div class="value">{{inventoryAction().estimated_completion_date | date}}</div>
    }
    @if (isAnswered && inventoryAction().expiration_date) {
      <div class="name">Fecha Vencimiento de Oferta</div>
      <div class="value">{{inventoryAction().expiration_date | date}}</div>
    }
    @if (isFinished) {
      <div class="name">Fecha de Finalización</div>
      <div class="value">{{inventoryAction().completed_at | date}}</div>
    }
    @if (inventoryAction().comment) {
      <div class="name">Comentario del Proveedor</div>
      <div class="value">{{inventoryAction().comment}}</div>
    }
  </div>

  <div>
    <div class="label">
     @if (answeredAt) {
       <p>{{'InventoryAction::Pricing' | human}} respondida el {{answeredAt | date}}</p>
   
       @if (!isFinished &&inventoryAction().expiration_date) {
         @if (hasExpired) {
           <p>, Oferta vencida</p>
         } @else {
           <p>, Vence en {{remainingDaysToExpire}} {{remainingDaysToExpire == 1 ? 'día' : 'días'}}</p>
         }
       }
       
     }
     @else {
       <p>Cotizacion Pendiente de Respuesta</p>
     }
     </div>
   
     <app-pricing-edit-form [document]="inventoryAction()"></app-pricing-edit-form>
     
  </div>

</ng-template>
